import { Component, Input } from '@angular/core';

type PortalStatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'purple';

const STATUS_TONES: Record<string, PortalStatusTone> = {
  paid: 'success',
  partially_paid: 'warning',
  ready_for_payment: 'info',
  in_review: 'warning',
  ready_for_review: 'warning',
  approved: 'info',
  issued: 'purple',
  dispatched: 'info',
  collecting: 'warning',
  closed: 'success',
  new: 'purple',
  draft: 'neutral',
  deleted: 'danger',
  canceled: 'danger',
  cancelled: 'danger',
  rejected: 'danger',
  expired: 'danger',
  outstanding: 'danger',
  todo: 'neutral',
  to_do: 'neutral',
  in_progress: 'warning',
  blocked: 'danger',
  done: 'success',
  completed: 'success',
};

@Component({
  selector: 'app-portal-status-pill',
  templateUrl: './portal-status-pill.component.html',
  styleUrls: ['./portal-status-pill.component.scss'],
})
export class PortalStatusPillComponent {
  @Input() status = '';
  @Input() label = '';
  @Input() tone?: PortalStatusTone;
  @Input() showDot = false;

  get displayLabel(): string {
    if (this.label) {
      return this.label;
    }

    return (this.status || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  get toneClass(): string {
    const normalized = (this.status || '').toLowerCase();
    return `portal-status-pill--${this.tone || STATUS_TONES[normalized] || 'neutral'}`;
  }
}
